import { ImageConfig } from '@teamfoster/sdk/image';

export const ImageSettings: Partial<ImageConfig> = {
  placeholderUrl: '/media/hedon-placeholder.png',
  defaultFormat: 'webp',
};
